import React from 'react';
import { RadioButton } from './common';

class RadioButtonChonTrangThaiXuLyDon extends React.Component {

  onChange(e) {
    this.props.onChange(e);
  }

  render() {

    let data = [
      {
        ten: 'CÔNG VIỆC ĐANG XỬ LÝ',
        giaTri: 'DANG_XU_LY'
      },
      {
        ten: 'CÔNG VIỆC ĐÃ XỬ LÝ',
        giaTri: 'DA_XU_LY'
      }
    ]

    return (
      <RadioButton options={data} disable={this.props.disable}
        selectedValue={this.props.selectedValue}
        keyName='giaTri'
        valueName='ten'
        onChange={this.onChange.bind(this)} />
    )
  }
}

RadioButtonChonTrangThaiXuLyDon.defaultProps = {
  selectedValue: 'DANG_XU_LY',
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  }
}

export default RadioButtonChonTrangThaiXuLyDon;




// WEBPACK FOOTER //
// ./src/components/tt-forms/radiobutton-chontrangthaixulydon.jsx